
import Vue from 'vue';
import axios from 'axios';
import { CourseModel } from '@descomplica/dex-models';
import SentryClient from '@/helpers/sentry';
import { Loading } from '@descomplica/vue-components';
import ConfettiFloating from '@/components/animations/ConfettiFloating.vue';
import { CourseCertificateModel } from '@/models/studentDocuments';
import Analytics from '@/helpers/analytics';
import { TrackCertificateDefaultParams } from '@/helpers/analytics/types';
import { EVENT_LABELS } from '@/helpers/analytics/labels';

export const VIDEO_WATCHED_KEY = 'certificate-celebration-watched';

interface Data {
  finishedFetching: boolean;
  percentageWatched: number;
}

export default Vue.extend({
  components: {
    Loading,
    ConfettiFloating,
  },
  props: {
    defaultTrackingParams: {
      type: Object as Vue.PropType<TrackCertificateDefaultParams>,
      required: true,
    },
  },
  data(): Data {
    return {
      finishedFetching: false,
      percentageWatched: 0,
    };
  },
  computed: {
    certificateByCourseId(): CourseCertificateModel | null {
      return this.$store.getters.certificateByCourseId(this.currentCourse.id);
    },
    studentName(): string {
      return this.certificateByCourseId!.studentName;
    },
    currentCourse(): CourseModel {
      return this.$store.getters.currentCourse;
    },
  },
  async beforeMount() {
    try {
      await axios.get(
        'https://classrooms-assets.s3.sa-east-1.amazonaws.com/post-grad/celebration.mp4',
      );

      this.finishedFetching = true;
    } catch (err) {
      Analytics.trackEvent(EVENT_LABELS.postgradStudentDocumentsVideoError, {
        ...this.defaultTrackingParams,
      });
      SentryClient.captureError(err);

      this.finishedFetching = true;
      this.$emit('next');
    }
  },
  methods: {
    onVideoProgress(event: any): void {
      const { duration, currentTime } = event.target;
      this.percentageWatched = Math.floor((currentTime * 100) / duration);

      if (this.percentageWatched === 100) {
        Analytics.trackEvent(EVENT_LABELS.postgradStudentDocumentsVideoWatched, {
          ...this.defaultTrackingParams,
        });
      }
    },
    next(): void {
      localStorage.setItem(VIDEO_WATCHED_KEY, 'true');

      this.$emit('next', { percentage: this.percentageWatched });
    },
  },
});
